/**
 * Get a cookie value by name
 * @param {string} name - The name of the cookie to retrieve
 * @returns {string} - The cookie value or empty string if not found
 */
export const getCookie = (name) => {
	const value = `; ${document.cookie}`;
	const parts = value.split(`; ${name}=`);
	if (parts.length === 2) {
		return parts.pop().split(';').shift();
	}
	return '';
};
